//TODO: CHECK IF THIS IS NEEDED
export enum Area {
	BALKAN = 'balkan',
  COUNTRIES = 'countries',
	GRID10KM = '01deg',
  GRID1KM = '30arcsec',
	COLOR = 'color',
	PATTERN = 'pattern',
  NESTED = 'nested',
  GOOGLE = 'google',
}
